import { FC, useEffect, useState } from "react";
import { Collapse, Spin } from "antd";
// import DonutChart from "../donut-chart";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";
// import { spacedString} from "@pages/utils/utils";
import Icon from "@assets/icon_config";
import "./intellectual.scss";
import { SDImageCard, SDProgressCard } from "../card";
import {getDisplayValueBasedOnType as getDisplayValue} from "@utils/helpers";
import { cloneDeep } from 'lodash'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const Intellectual: FC<any> = (props) => {
  const dataCardId = "9";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=>{
    console.log("Intellectual.useEffect");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  // const houseHoldData = props?.data?.householdEducation
  //   ? Object.entries(props?.data?.householdEducation).map(([key, val]) => ({ type: spacedString(key), value: val || 0 }))
  //   : [];

  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>;

  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );
  return (
    <Collapse accordion activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
      <Panel className="title ui-intellectual" header={getHeading("Education / Occupation / Crime Rate")} key="1" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
        <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
          <div className="ui-intellectual__card-items">
            <SDImageCard title="High School Education" image={<Icon name={"highSchool"} />} value={getDisplayValue(props?.data?.highSchoolEducation, "percent")} />
            <SDImageCard title="Associate Degree Or Higher" image={<Icon name={"associateDegree"} />} value={getDisplayValue(props?.data?.associateDegreeOrHigher, "percent")} />
            <SDImageCard title="Bachelor's Degree" image={<Icon name={"bachelorDegree"} />} value={getDisplayValue(props?.data?.bachelorDegree, "percent")} />
            <SDProgressCard title="School Enrollment" value={props?.data?.schoolEnrolment} />
            <SDProgressCard title="Employment Rate" value={props?.data?.employmentRate} />
            <SDProgressCard title="Neighborhood Crime Rate" value={props?.data?.neighborhoodCrimeRate} />
          </div>
        </Spin>
      </Panel>
    </Collapse>
  );
};

export default Intellectual;
